var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWirelessCharging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#007AFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1267_2518)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1267_2518",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 7.5H7V23.5H23V7.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1267_2518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.043 20.5C15.7399 20.5081 16.4314 20.3767 17.0769 20.1137C17.7224 19.8507 18.3087 19.4614 18.8016 18.9685C19.2944 18.4757 19.6838 17.8893 19.9468 17.2439C20.2098 16.5984 20.3411 15.9069 20.3331 15.21C20.3091 12.264 17.9024 9.85668 14.9564 9.83335C14.2595 9.8254 13.568 9.9568 12.9226 10.2198C12.2772 10.4829 11.6909 10.8722 11.198 11.365C10.7052 11.8578 10.3159 12.4442 10.0528 13.0896C9.78981 13.735 9.65841 14.4264 9.66636 15.1233C9.69036 18.0693 12.097 20.4767 15.043 20.5Z",
    stroke: "white",
    strokeWidth: 0.886076,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 23.1667C14.5 23.2993 14.5527 23.4265 14.6465 23.5202C14.7402 23.614 14.8674 23.6667 15 23.6667C15.1326 23.6667 15.2598 23.614 15.3535 23.5202C15.4473 23.4265 15.5 23.2993 15.5 23.1667H14.5ZM14.5 22.5V23.1667H15.5V22.5H14.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5707 13.167L13.666 15.167H16.3327L14.428 17.167",
    stroke: "white",
    strokeWidth: 0.886076,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5V21.5C16 21.8107 16 21.966 15.9493 22.0887C15.8815 22.2517 15.7518 22.3812 15.5887 22.4487C15.466 22.5 15.3107 22.5 15 22.5C14.6893 22.5 14.534 22.5 14.4113 22.4493C14.2483 22.3815 14.1188 22.2518 14.0513 22.0887C14 21.966 14 21.8107 14 21.5V20.5",
    stroke: "white",
    strokeWidth: 0.886076
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1267_2518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWirelessCharging);
export default __webpack_public_path__ + "static/media/WirelessCharging.1b60ee0e93e249731574b4101ca03a1b.svg";
export { ForwardRef as ReactComponent };